import React from "react";
import { Typography } from "@mui/material";

import useAssessmentStore from "components/Assessment/assessmentStore";

/**
 * Per-question countdown (mobile) — same logic as `Assessment/CountDown`.
 *
 * Only ticks while RECORDING, and auto-submits the answer when the question's
 * allottedTime runs out. Renders `mm:ss/mm:ss` (elapsed budget / total).
 */
export default function CountDown({ state, question }) {
  const submit = useAssessmentStore((s) => s.submit);
  const timeLeft = useAssessmentStore((s) => s.timeLeft);
  const setTimeLeft = useAssessmentStore((s) => s.setTimeLeft);

  React.useEffect(() => {
    let timeoutId;
    if (state === "RECORDING") {
      if (timeLeft === 0) {
        submit();
      } else if (timeLeft > 0) {
        timeoutId = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      }
    }
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeLeft, state]);

  React.useEffect(() => {
    if (question) setTimeLeft(question.allottedTime);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question]);

  const total = question?.allottedTime || 0;

  return (
    <Typography variant="body01-semiBold" color="neutral.clr-700">
      {format(timeLeft)}/{format(total)}
    </Typography>
  );
}

function format(seconds = 0) {
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m < 10 ? "0" : ""}${m}:${s < 10 ? "0" : ""}${s}`;
}
